// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { invoiceDetailSchema } from '@/billing/api/types';
import { z } from 'zod';

const revertInvoiceToDraftResponseSchema = z.object({
  data: invoiceDetailSchema,
  metadata: responseMetadataSchema,
});

export async function revertInvoiceToDraft(invoiceKey: string) {
  const url = `/v1/invoice/${invoiceKey}/revert-to-draft`;
  const response = await api.post(url);

  const result = await parseResponse(
    revertInvoiceToDraftResponseSchema,
    response.data,
    {
      schemaName: 'RevertInvoiceToDraft',
      endpoint: url,
    }
  );
  return result.data;
}
